export default __webpack_public_path__ + "static/media/252.a02be7c4.gif";